module.exports = __webpack_public_path__ + "img/103-marshall-island.cf0286fc.svg";